import { Inject, Injectable } from '@angular/core'
import { StateControllerService, StateUpdateDto } from '../../../api/backend'
import { Observable } from 'rxjs'

@Injectable({
    providedIn: 'root'
})
export class HeaderMenuService {

    constructor(@Inject(StateControllerService) private stateControllerService: StateControllerService) {
    }

    getHeaderMenuItems(): Array<{
        class: string;
        route: string;
        title: string;
        text: string;
    }> {
        return [
            {
                class: 'fa-home',
                route: '/landingPage',
                title: 'Klikněte pro návrat na úvodní stránku.',
                text: 'Na úvodní stránku'
            },
            {
                class: 'fa-file-text-o',
                route: '/contracts',
                title: 'Přejít na seznam pachtovních smluv.',
                text: 'Pachtovní smlouvy'
            },
            {
                class: 'fa-files-o',
                route: '/subcontract',
                title: 'Přejít na seznam podpachtovních smluv.',
                text: 'Podpachtovní smlouvy'
            },
            {
                class: 'fa-users',
                route: '/subjects',
                title: 'Přejít na seznam osob.',
                text: 'Osoby'
            },
            {
                class: 'ci ci-coin-czk',
                route: '/payments',
                title: 'Přejít na platby.',
                text: 'Platby'
            },
            {
                class: 'fa-object-group',
                route: '/parcels',
                title: 'Přejít na seznam parcel.',
                text: 'Parcely'
            },
            {
                class: 'fa-map',
                route: '/map',
                title: 'Přejít na mapu.',
                text: 'Mapa'
            },
            {
                class: 'fa-calculator',
                route: '/taxes',
                title: 'Přejít na daňová přiznání.',
                text: 'Daňová přiznání'
            },
            {
                class: 'fa-exchange',
                route: '/barter',
                title: 'Přejít na směny užívání.',
                text: 'Směny užívání'
            },
            {
                class: 'fa-building',
                route: '/buildings',
                title: 'Přejít na budovy.',
                text: 'Budovy'
            },
            {
                class: 'fa-clock-o',
                route: '/bulkOperation',
                title: 'Přejít na hromadné operace.',
                text: 'Hromadné operace'
            },
            {
                class: 'fa-folder-open-o',
                route: '/group',
                title: 'Přejít na skupiny smluv a parcel.',
                text: 'Skupiny'
            },
            {
                class: 'fa-bar-chart',
                route: '/statistics',
                title: 'Přejít na reporty a analýzy.',
                text: 'Reporty, analýzy'
            },
            {
                class: 'fa-shopping-bag',
                route: '/purchase',
                title: 'Přejít na nákupy půdy.',
                text: 'Nákupy půdy'
            },
            {
                class: 'fa-file-o',
                route: '/template',
                title: 'Přejít na šablony dokumentů.',
                text: 'Šablony dokumentů'
            },
            {
                class: 'fa-file-text-o',
                route: '/nonCadastral',
                title: 'Přejít na smlouvy mimo data katastru.',
                text: 'Smlouvy mimo data katastru'
            },
            {
                class: 'ci ci-geo-data',
                route: '/cadastralData',
                title: 'Přejít na data katastru nemovitostí.',
                text: 'Data katastru nemovitostí'
            },
            {
                class: 'fa-coffee',
                route: '/admin',
                title: 'Přejít na administrační modul.',
                text: 'Administrace'
            },
        ]
    }

    getStateUpdate(projectKey: string): Observable<StateUpdateDto> {
        return this.stateControllerService.getUpdate(projectKey)
    }
}
